// extracted by mini-css-extract-plugin
export var activityContainer = "_ls-0";
export var typingIndicatorContainer = "_ls-1";
export var typingIndicatorDot = "_ls-2";
export var wave = "_ls-3";